/**
 * Shared constant for the upgrade CTA text used in quota paywall messages.
 * Must match the text sent by the backend in QUOTA_EXCEEDED_MESSAGES (chat_manager.py).
 * Used for:
 * - Splitting the assistant message to insert a clickable CTA (QuotaExceededCTA)
 * - Detecting paywall messages on reload (convertChatMessages)
 * - Detecting paywall messages during rendering (ChatTimeline)
 */
export const QUOTA_UPGRADE_CTA_TEXT = 'Upgrade your plan to Clinician';

/**
 * Markdown link to billing settings. Link label is intentionally not matched so
 * localized copy (e.g. `[Upgrade to Clinician](/settings/billing)`) still counts.
 */
const QUOTA_EXHAUSTED_BILLING_MD_LINK_PATTERN =
  /\[[^\]]*\]\(\s*(?:\/settings\/billing\/?|https?:\/\/[^/)\s]+\/settings\/billing\/?)(?:[#?][^)]*)?\s*\)/i;

/** True when assistant text includes a markdown upgrade link to billing settings. */
export function textContainsQuotaExhaustedBillingLink(text: string): boolean {
  return QUOTA_EXHAUSTED_BILLING_MD_LINK_PATTERN.test(text);
}
